import { Button, Typography, Link } from '@mui/material'
import { useFormikContext } from 'formik'

import { IAccountCreateCheckRespDto } from 'src/types'
import { useCreateAccountCheckAccept } from 'src/hooks'
import useStyles from './styles'
import { ExistingAccountTooltip } from 'src/components/existing-account-tooltip'
import { TRACKGOOD_SUPPORT_EMAIL } from 'src/constants'
import { HelperWrapper } from 'src/components/helper-wrapper'

interface IProps {
  existsData: NonNullable<IAccountCreateCheckRespDto>
}

export const ExistsAccountButton = ({ existsData }: IProps) => {
  const classes = useStyles()
  const { setSubmitting, isSubmitting } = useFormikContext()
  const { mutateAsync: acceptExisting } = useCreateAccountCheckAccept()

  const handleClick = async () => {
    setSubmitting(true)
    await acceptExisting(existsData.id)
    setSubmitting(false)
  }

  return (
    <div className={classes.existsWrapper}>
      <Typography className={classes.existsText}>
        <HelperWrapper t="account-create-exists-1" />
        <ExistingAccountTooltip existingAccount={existsData} />
        <br />
        {existsData.hasOwner ? (
          <HelperWrapper t="account-create-exists-owner-1" />
        ) : (
          <HelperWrapper t="account-create-exists-2" />
        )}
      </Typography>
      <div>
        {existsData.hasOwner ? (
          <Button
            size="small"
            LinkComponent={Link}
            target="_blank"
            variant="contained"
            href={`mailto:${TRACKGOOD_SUPPORT_EMAIL}`}
            sx={{ display: 'flex' }}
          >
            <HelperWrapper t="contact-us-button-text" />
          </Button>
        ) : (
          <Button
            size="small"
            onClick={handleClick}
            disabled={isSubmitting}
            variant="contained"
            sx={{ display: 'flex' }}
          >
            <HelperWrapper t="account-create-exists-3" />
          </Button>
        )}
      </div>
    </div>
  )
}
